import { Drawer, Button } from "antd"
import { FilterOutlined, CloseOutlined } from "@ant-design/icons"
import AutoCompleteBox from "../AutoCompleteBox/AutoCompleteBox"

const FilterDrawer = ({
  filters = {},
  setFilters,
  onApply,
  onClear,
  fields = [],
  drawerOpen,
  setDrawerOpen,
}) => {
  const activeFilterCount = Object.values(filters).filter(
    (val) => val && val.trim() !== ""
  ).length
  return (
    <>
      <Button
        size="small"
        onClick={() => setDrawerOpen(true)}
        className="position-relative"
      >
        <FilterOutlined />
        {activeFilterCount !== 0 && <span>({activeFilterCount})</span>}
      </Button>

      <Drawer
        className="filter-drawer"
        title={
          <div className="d-flex justify-content-between align-items-center w-100">
            <span>Apply Filter</span>
            <CloseOutlined
              onClick={() => setDrawerOpen(false)}
              className="rounded-circle p-1"
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.1)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
              style={{ color: "rgba(0,0,0,0.6)", fontSize: "12px" }}
            />
          </div>
        }
        mask={false}
        placement="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        width={300}
      >
        <div className="d-flex flex-column justify-content-between h-100">
          <div className="p-3">
            {fields.map(({ label, name, endPoint, placeholder }) => (
              <AutoCompleteBox
                key={name}
                label={label}
                name={name}
                className="mb-3 w-100"
                endPoint={endPoint}
                placeholder={placeholder}
                value={filters && filters[name] ? filters[name] : ""}
                onChange={(value) =>
                  setFilters((prev) => ({ ...prev, [name]: value }))
                }
              />
            ))}
          </div>
          <div className="p-3 d-flex gap-2 ">
            <Button
              size="small"
              className="btn-form-filter btn-form-filter--clear rounded-pill"
              onClick={onApply}
              type="primary"
            >
              Apply Filter
            </Button>
            <Button
              size="small"
              className="btn-form-filter btn-form-filter--clear rounded-pill"
              onClick={onClear}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 0 5px 1px rgba(0, 0, 0, 0.2)"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none"
              }}
            >
              Clear Filter
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  )
}

export default FilterDrawer
